import {
  EditGPDAddReportTask,
  EditGPDStartRegistrationTask,
  GPDAddReportTask,
  GPDEndRegistrationTask,
  GPDStartRegistrationTask,
  QualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { createGpdUiSchemaLibrary } from "./gpd-ui-schema-library";

/**
 * Unified UI Schema hook for all GPD forms.
 */
export function useGpdUiSchema(
  qualityRegime: QualityRegimeOptions | undefined
): BrostarUiSchema<
  | GPDStartRegistrationTask
  | EditGPDStartRegistrationTask
  | GPDAddReportTask
  | EditGPDAddReportTask
  | GPDEndRegistrationTask
> {
  const lib = createGpdUiSchemaLibrary(qualityRegime);

  return {
    "ui:order": ["metadata", "reportFile", "volumeFile", "sourcedocumentData"],
    metadata: {
      "ui:title": "Metadata",
      projectNumber: lib.projectNumber,
      broId: lib.broId,
      qualityRegime: lib.qualityRegime,
      deliveryAccountableParty: lib.deliveryAccountableParty,
      correctionReason: lib.correctionReason,
    },
    reportFile: lib.reportFile,
    volumeFile: lib.volumeFile,
    sourcedocumentData: {
      "ui:title": "Brondocumentgegevens",
      // Start Registration fields
      objectIdAccountableParty: lib.objectIdAccountableParty,
      publiclyAvailable: lib.publiclyAvailable,
      // Add report fields
      reportId: lib.reportId,
      method: lib.method,
      groundwaterUsageFacilityBroId: lib.groundwaterUsageFacilityBroId,
      volumeSeries: lib.volumeSeries,
    },
  };
}
